// extracted by mini-css-extract-plugin
export default {"titleBox":"styles_titleBox__+MkjZ","text":"styles_text__LtjKb","stepper":"styles_stepper__NNEqN"};